export interface TemplateKeyProps {
  key: string;
  value: string;
}

export class Template {
  constructor(
    public id = 0,
    public name = '',
    public keys = '',
    public template_file_base64 = '',
    public path = '',
    public url = '',
    public has_mappings?: boolean,
    public is_active?: boolean,
  ) {}
}
